import { render, staticRenderFns } from "./bcSales.vue?vue&type=template&id=fe401a7e&"
import script from "./bcSales.vue?vue&type=script&lang=js&"
export * from "./bcSales.vue?vue&type=script&lang=js&"
import style0 from "./bcSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports